<template lang='pug'>
  .fpui-input-search(:class='`fpui-input-color-${color}`')
    i.fpui.fpui-search(:class='{ right: icon === "right" }')
    fpui-input-text(
      :class='{ right: icon === "right" }'
      v-model='model'
      v-bind='props',
      placeholder='Search',
      :autofocus='autofocus',
      :autocomplete='autocomplete'
    )
</template>

<script>

export default {
  props: {
    name: { type: String },
    icon: { type: String, default: 'left' },
    value: { type: String, required: true, default: '' },
    color: { type: String, default: 'blue' },
    disabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    placeholder: { type: String },
    autocomplete: { type: Array },
    type: { type: String, default: 'text' },
    autofocus: { type: Boolean, default: false }
  },
  computed: {
    model: {
      get () { return this.value },
      set (val) { return this.$emit('input', val) }
    },
    props () {
      return {
        name: this.name,
        value: this.value,
        color: this.color,
        disabled: this.disabled,
        error: this.error,
        placeholder: this.placeholder,
        autocomplete: this.autocomplete,
        type: this.type,
        autofocus: this.autofocus
      }
    }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";

.fpui-input-search {
  width: 100%;
  position: relative;
  &.fpui-input-color-blue i {
    color: @blue;
  }
  &.fpui-input-color-green i {
    color: @green;
  }
  &.fpui-input-color-yellow i {
    color: @yellow;
  }
  &.fpui-input-color-red i {
    color: @red;
  }
  &.fpui-input-color-grey i {
    color: @grey;
  }
  i.fpui {
    z-index: 10;
    position: absolute;
    left: 0;
    height: 35px;
    width: 35px;
    line-height: 35px;
    font-size: 20px;
    text-align: center;
    &.right {
      right: 0;
      left: initial;
    }
  }
  .fpui-input-text {
    input {
      padding-left: 35px;
    }
    &.right {
      input {
        padding-left: 12px;
        padding-right: 35px;
      }
    }
  }
}
</style>
